import { SVGProps } from "react";

export function CricketIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.5 1L5 4.38L7.5 7.5L11 4L9.5 1Z" />
      <path d="M7.5 7.5L4.38 10.62L2.12 8.12L5 4.38L7.5 7.5Z" />
      <path d="M15.88 12.88L19 10L22 14L19 17L15.88 12.88Z" />
      <path d="M12.5 4L10 6.5L13.5 10L16 7.5L12.5 4Z" />
      <path d="M4.38 10.62L1.5 13.5L4.5 16.5L7.38 13.62L4.38 10.62Z" />
      <path d="M10 6.5L7.5 9L11 12.5L13.5 10L10 6.5Z" />
      <path d="M7.5 9L4.38 12.12L7.38 15.12L10.5 12L7.5 9Z" />
      <path d="M15.12 15.88L13.5 14.25C12.5 16 11.25 18.75 11.25 18.75L12.75 20.25L17.75 15.75C17.75 15.75 16 14.5 15.12 15.88Z" />
      <path d="M11.25 18.75C9.75 20.5 9.25 22.5 11 23C12.75 23.5 14.25 21.25 14.25 21.25L12.75 20.25L11.25 18.75Z" />
    </svg>
  );
}
